import React, { useState, useEffect, useContext } from "react";
import { ethers } from "ethers";
import { appContext } from "../App";
import logo from "../assets/images/logo.png";
import polygonIcon from '../assets/images/polygon-icon.webp'
import songbirdIcon from '../assets/images/songbird-alt.svg'
import { useConnect } from "wagmi";
import { InjectedConnector } from "@wagmi/core";
import contractABI from '../assets/abi.json'
import { useWeb3Modal } from "@web3modal/react";


const Login = () => {

  const [error, setError] = useState("");
  const [totalMinted, setTotalMinted] = useState("...")
  const [, saleComplete, setSaleComplete] = useContext(appContext)
  const [loading, setLoading] = useState(true)
  const [isWhiteListOnly, setIswhitelistOnly] = useState(false)
  
  const { connect } = useConnect({
    connector: new InjectedConnector()
  })

  const { open } = useWeb3Modal()

  const [contractAddress] =
    useContext(appContext);

  // deployment
  // const rpcURL = "https://polygon-mumbai.blockpi.network/v1/rpc/public	";
  // prod
  const rpcURL = "https://sgb.ftso.com.au/ext/bc/C/rpc";


  useEffect(() => {
    mintCheck();
  }, []);

  async function ConnectWallet() {
    // if (!window.ethereum) {
    //   connect()
    // }
    // else {
      open()
    // }
  }

 

  async function mintCheck() {
    const contract = new ethers.Contract(
      contractAddress,
      contractABI,
      new ethers.providers.getDefaultProvider(
        rpcURL
      )
    );
    try {
      const response = (await contract.totalSupply()).toString();
      setTotalMinted(response);
      if (response > 2500) {
        setSaleComplete(true);
      }
      console.log(response);
    } catch (err) {
      console.log(err);
    }
    try {
      const response = (await contract.whitelistOnly());
      setIswhitelistOnly(response)
      console.log(response);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);

  }

  return (
    <div className="Container">
      <div className="transparentBox">
        <div className="logoDiv">
          <img width={55} height={55} style={{ marginLeft: "-25px", marginRight: '5px' }} src={logo} />
          <h4>Citizens Of Gokubi</h4>
          <h6 style={{ position: 'absolute', bottom: '-4px' }} className="altfont">NFT Collection</h6>
        </div>
        <div style={{ position: 'absolute', top: '140px' }}>

          <h6 className="altfont">Status</h6>
          <hr/>{!loading?<>
          {!saleComplete?<>
          <div style={{display:'flex'}}>
          <div className="icon">
          </div>{!isWhiteListOnly?
          <h6>Live on <img width={25} src={songbirdIcon} /></h6>
          :<h6>Whitelist Only!</h6>
          }
          </div>
            </>:
            <h6>Sale Stopped!</h6>
          }</>:<></>}
        </div>
        <div className="notLogoDiv">
          <h4 className="altfont"> {totalMinted}/2500 NFTs Minted!</h4>
          <button
            className="buttonConnect"
            onClick={() => {
              if (!saleComplete && !loading)
                ConnectWallet();
            }}
          >
            {!loading ? <>{saleComplete ? <>Sold OUT!</> : <>Connect Wallet</>}</> : <>...</>}
          </button>
          <h6 style={{ position: 'absolute', bottom: '76px' }}>Connect Wallet To Mint!</h6>
          <h6 style={{ position: 'absolute', bottom: '0', marginBottom: '5px', letterSpacing: "1.5px", color: "yellow" }}>{error}</h6>
        </div>
      </div>
    </div>
  );
};

export default Login;

